import { z } from 'zod';
export const meetingTranscriptSearchBodySchema = z.object({
    query: z.string().default(''),
    limit: z.number().int().min(1).max(50).default(20),
    offset: z.number().int().min(0).default(0),
    meetingDateAfter: z.iso.date().optional(),
    meetingDateBefore: z.iso.date().optional(),
});
